module.exports = __webpack_public_path__ + "static/media/prev.6eb4986b.svg";